import { render } from "./SMSAction.vue?vue&type=template&id=3c53bb2e&scoped=true"
import script from "./SMSAction.vue?vue&type=script&lang=js"
export * from "./SMSAction.vue?vue&type=script&lang=js"

import "./SMSAction.vue?vue&type=style&index=0&id=3c53bb2e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c53bb2e"]])

export default __exports__